import React from 'react';
import { useEffectOnce } from 'react-use';
import { connect } from 'react-redux';
import store from '../../redux/store';
import { getAnnouncement } from '../../redux/modules/announcement/action';
import Notification from '../Notification';

const NotificationGroup = ({ ...props }) => {
  useEffectOnce(() => {
    store.dispatch(getAnnouncement());
  });

  const { announcement } = props;
  const { data } = announcement;

  const notifications = () => {
    return data.map((v, k) => {
      return <Notification key={k} data={v} />;
    });
  };

  return <>{notifications()}</>;
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  announcement: state.announcement,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(NotificationGroup);

export { NotificationGroup as NotificationGroupComponent }; // <- For component Unit Test
export default connectStore;
